import React from 'react';
import { useAuthStore, StaffRole } from '@/stores/auth.store';
import type { AuthUser } from '@/discord/types/auth';

// Pont : le dashboard d'origine récupérait l'utilisateur via /users/me (OAuth Discord).
// Ici on garde NOTRE auth : l'utilisateur est dérivé de auth.store (login Recube).
// MeProvider est un simple pass-through (pas de fetch), useMe lit nos stores.

export function MeProvider({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}

export function useMe(): { user: AuthUser | null; loading: boolean; refetch: () => void } {
  const u = useAuthStore((s) => s.user);
  const user: AuthUser | null = u
    ? {
        id: u.id,
        username: u.gamertag,
        avatar: u.avatarUrl ?? null,
        // L'espace Discord est réservé aux admins ; on mappe en conséquence.
        role: u.isAdmin || u.role === StaffRole.ADMIN ? 'admin' : 'player',
      }
    : null;
  return { user, loading: false, refetch: () => {} };
}
